// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4392fa3e","453":"c364626f","455":"8da133c8"}[chunkId] + ".chunk.js";
};